var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.align),function(a){return _c('v-card',{key:a,class:`d-flex align-${a} mb-6`,attrs:{"color":"grey lighten-2","flat":"","height":"100","tile":""}},_vm._l((3),function(n){return _c('v-card',{key:n,staticClass:"pa-2",attrs:{"outlined":"","tile":""}},[_vm._v(" Flex item ")])}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }